import type { CSSProperties } from 'react';

/** Couleur d'une équipe (Team::color côté API) : #rrggbb, en minuscules */
export const isHexColor = (color: unknown): color is string =>
  typeof color === 'string' && /^#[0-9a-f]{6}$/.test(color);

/** Gris des équipes sans couleur (facultative) */
export const NO_TEAM_COLOR = '#64748b';

/** Raccourcis proposés à côté du color picker */
export const TEAM_COLOR_PRESETS = [
  { label: 'Rouge', color: '#ef4444' },
  { label: 'Orange', color: '#f97316' },
  { label: 'Ambre', color: '#f59e0b' },
  { label: 'Vert', color: '#22c55e' },
  { label: 'Turquoise', color: '#14b8a6' },
  { label: 'Ciel', color: '#0ea5e9' },
  { label: 'Bleu', color: '#3b82f6' },
  { label: 'Indigo', color: '#6366f1' },
  { label: 'Violet', color: '#8b5cf6' },
  { label: 'Rose', color: '#ec4899' },
] as const;

/** Couleur affichée : la sienne, gris sans couleur (ou valeur inattendue) */
export const teamColorOf = (color: string) => (isHexColor(color) ? color : NO_TEAM_COLOR);

/**
 * Tag aux couleurs de l'équipe, quelle que soit la couleur choisie : fond très clair, bordure claire, texte foncé
 * (lisible même pour une couleur claire). En mode nuit, mêlée au fond sombre et texte éclairci (variables
 * --team-tag-* de src/styles/dark.css ; valeurs claires par défaut)
 */
export const teamTagStyle = (color: string): CSSProperties => {
  const base = teamColorOf(color);

  return {
    backgroundColor: `color-mix(in srgb, ${base} var(--team-tag-bg-mix, 12%), var(--team-tag-surface, white))`,
    borderColor: `color-mix(in srgb, ${base} var(--team-tag-border-mix, 35%), var(--team-tag-surface, white))`,
    color: `color-mix(in srgb, ${base} var(--team-tag-text-mix, 55%), var(--team-tag-ink, black))`,
  };
};
